export default __webpack_public_path__ + "static/media/icon-User.111b6e2a.svg";